import { render, staticRenderFns } from "./AssessmentRegistrationApp.vue?vue&type=template&id=af03dbc2&scoped=true"
import script from "./AssessmentRegistrationApp.vue?vue&type=script&lang=js"
export * from "./AssessmentRegistrationApp.vue?vue&type=script&lang=js"
import style0 from "./AssessmentRegistrationApp.vue?vue&type=style&index=0&id=af03dbc2&prod&scoped=true&lang=css"
import style1 from "./AssessmentRegistrationApp.vue?vue&type=style&index=1&id=af03dbc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af03dbc2",
  null
  
)

export default component.exports